// Finishing a sign-in, shared by the sign-in card, the code step and the reset / invite screens: remember the email,
// work out where the user was going, sign in, then go there (unless this tab was already signed in). When the server
// named sign-in prompts, they come first: the target is kept for after them (views/SignInPrompts.vue).
export const completeSignIn = (user, { login, router, reLogin = false, redirectRoute = null }) => {
    localStorage.setItem('other-tab-login', '')
    localStorage.setItem('lastLogin', user?.email)
    const redirectTarget = redirectRoute || sessionStorage.getItem('redirectTarget') || '/'
    const prompts = Array.isArray(user?.prompts) ? user.prompts : []
    if (prompts.length) {
        sessionStorage.setItem('signInPrompts', JSON.stringify(prompts))
        sessionStorage.setItem('redirectTarget', redirectTarget)
    } else {
        // A queue left by an earlier sign-in in this tab (another user, on a shared browser) never carries over.
        sessionStorage.removeItem('signInPrompts')
        sessionStorage.removeItem('redirectTarget')
    }
    login(user)
    if (!reLogin) { router.push(prompts.length ? { name: 'Sign-in Prompts' } : redirectTarget) }
}
